module.exports = __webpack_public_path__ + "img/default-product.402a567e.png";